module.exports = __webpack_public_path__ + "static/media/close.0a99202e.svg";